import React from 'react';
import { processSteps } from '../data/mock';

const Process = () => {
  return (
    <section id="process" className="bg-[#0d0d0d] py-20 md:py-32">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="font-['Bebas_Neue'] text-white text-5xl md:text-7xl tracking-wide">
            SIMPLE PROCESS. STUNNING RESULTS.
          </h2>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {processSteps.map((step, index) => (
            <div key={index} className="relative">
              {/* Step Number */}
              <div className="mb-6">
                <span className="font-['Bebas_Neue'] text-[#3f4816] text-6xl md:text-7xl leading-none">
                  {step.step}
                </span>
              </div>

              {/* Step Content */}
              <h3 className="font-['Bebas_Neue'] text-[#e8ff47] text-2xl md:text-3xl mb-4 leading-tight">
                {step.title}
              </h3>
              <p className="font-['DM_Sans'] text-[#888680] text-base leading-relaxed">
                {step.description}
              </p>

              {/* Connector Line (desktop only) */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-[#3f4816] opacity-30 -translate-x-1/2"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
